module.exports = __webpack_public_path__ + "img/reserve-active.3c21d1f1.png";